import {ChevronUpIcon} from '@kit';

import React from 'react';

import {Link, SiteRoutes} from '../../lib/routes';
import {cls} from '../utils';

import css from './breadcrumbs.module.css';

type Breadcrumb = {
	title: React.ReactNode;
	subTitle?: React.ReactNode;
	route?: keyof SiteRoutes;
	params?: SiteRoutes[keyof SiteRoutes];
};

type Props = {
	breadcrumbs: Breadcrumb[];
	className?: string;
};

export const Breadcrumbs: React.FC<Props> = ({breadcrumbs, className}) => {
	return (
		<nav className={cls(css.wrapper, className)} aria-label="Хлебные крошки">
			{breadcrumbs.map((breadcrumb, index) =>
				breadcrumb.route ? (
					<div key={index}>
						<Link route={breadcrumb.route} params={breadcrumb.params}>
							{breadcrumb.title}
						</Link>
						{index !== breadcrumbs.length - 1 && <ChevronUpIcon />}
					</div>
				) : (
					<div key={index}>
						<div aria-current="page">{breadcrumb.title}</div>
						{breadcrumb.subTitle && <div className={css.subTitle}>{breadcrumb.subTitle}</div>}
					</div>
				),
			)}
		</nav>
	);
};
